var generateComponentTheme = function generateComponentTheme(_ref) {
  var colors = _ref.colors,
    spacing = _ref.spacing,
    borders = _ref.borders;
  return {
    dropzoneBackgroundColor: colors.porcelain,
    dropzoneBorderWidth: borders.widthSmall,
    dropzoneBorderColor: colors.ash,
    dropzonePadding: spacing.medium
  };
};
export default generateComponentTheme;